import { PersonKnowledge } from '../util/PersonKnowledge'

import {
    SET_KNOWLEDGE_LIST,
    UPDATE_KNOWLEDGE_LIST
} from './Reducer'

export const setKnowledgeList = (knowledgeArray: PersonKnowledge[]) => {
    return {
        type: SET_KNOWLEDGE_LIST,
        payload: {
            knowledgeArray,
        },
    }
}

export const updateKnowledgeList = (knowledgeArray: PersonKnowledge[]) => {
    return {
        type: UPDATE_KNOWLEDGE_LIST,
        payload: {
            knowledgeArray
        },
    }
}
